var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M5.83333333,-2.22044605e-16 C2.61333333,-2.22044605e-16 -2.22044605e-16,2.61333333 -2.22044605e-16,5.83333333 C-2.22044605e-16,9.05333333 2.61333333,11.6666667 5.83333333,11.6666667 C9.05333333,11.6666667 11.6666667,9.05333333 11.6666667,5.83333333 C11.6666667,2.61333333 9.05333333,-2.22044605e-16 5.83333333,-2.22044605e-16 Z M5.83333333,8.75 C5.5125,8.75 5.25,8.4875 5.25,8.16666667 L5.25,5.83333333 C5.25,5.5125 5.5125,5.25 5.83333333,5.25 C6.15416667,5.25 6.41666667,5.5125 6.41666667,5.83333333 L6.41666667,8.16666667 C6.41666667,8.4875 6.15416667,8.75 5.83333333,8.75 Z M6.41666667,4.08333333 L5.25,4.08333333 L5.25,2.91666667 L6.41666667,2.91666667 L6.41666667,4.08333333 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1.167 1.167)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#A3AFB7",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(-1.167 -1.167)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoSmall);
export default __webpack_public_path__ + "static/media/icon_info_small.c9a1959f613210bb18aaf724c4395ff7.svg";
export { ForwardRef as ReactComponent };